// neurotrader-admin/src/components/AdminBottomNav.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiHome, FiUsers, FiPackage, FiBarChart2 } from 'react-icons/fi';
import './AdminBottomNav.css';

const AdminBottomNav = () => {
    return (
        <nav className="bottom-nav">
            <NavLink to="/" className="bottom-nav-link" end>
                <FiHome />
                <span>Dashboard</span>
            </NavLink>
            <NavLink to="/clientes" className="bottom-nav-link">
                <FiUsers />
                <span>Clientes</span>
            </NavLink>
            <NavLink to="/pedidos" className="bottom-nav-link">
                <FiPackage />
                <span>Pedidos</span>
            </NavLink>
            <NavLink to="/bots" className="bottom-nav-link">
                <FiBarChart2 />
                <span>Bots</span>
            </NavLink>
        </nav>
    );
};

export default AdminBottomNav;